import { render } from "./RestrictionDetail.vue?vue&type=template&id=d19b0cca&scoped=true"
import script from "./RestrictionDetail.vue?vue&type=script&lang=js"
export * from "./RestrictionDetail.vue?vue&type=script&lang=js"

import "./RestrictionDetail.vue?vue&type=style&index=0&id=d19b0cca&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d19b0cca"]])

export default __exports__